// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"31ad3acb","210":"1a1cfac2","404":"014a2095","570":"7c11d9eb","650":"3165d506","893":"d4eb082a","939":"0970e037"}[chunkId] + ".chunk.js";
};